<template>
    <div class="main-menu" :class="rootClasses">
        <div class="main-menu--background"/>
        <div class="main-menu--list">
            <div class="main-menu--items">
                <div class="main-menu--item main-menu--item__home-link">
                    <conditional-link class="u-reset main-menu--home-link" :to="{ name: home }">
                        <ui-icon class="main-menu--home-image" symbol="gk-logo"/>
                    </conditional-link>
                </div>
            </div>
        </div>

        <div class="main-menu--mobile-switcher">
            <transition name="trs-simple-fade">
                <mobile-switcher v-if="showMobileSwitcher"/>
            </transition>
        </div>

        <div class="main-menu--hamburger" :style="hamburgerStyles">
            <hamburger-btn/>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import { MAP_APP_RECORD_NAMES } from 'framework/router/route-data-configs';
    import { bemMixin, scrollLockHelperMixin } from '@dreipol/vue-ui/src/mixins';
    import ConditionalLink from 'framework/components/conditional-link/conditional-link';
    import HamburgerBtn from 'framework/components/hamburger-btn/hamburger-btn';
    import MobileSwitcher from 'framework/components/mobile-switcher/mobile-switcher';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';

    export default {
        components: {
            ConditionalLink,
            HamburgerBtn,
            MobileSwitcher,
            UiIcon,
        },
        mixins: [
            bemMixin('main-menu'),
            scrollLockHelperMixin,
        ],
        data() {
            return {
                home: MAP_APP_RECORD_NAMES.HOME,
            };
        },
        computed: {
            ...mapGetters('vue-ui/overlay', ['hasScrollLockingOverlays']),
            ...mapState('project-status', ['menuSidebar']),
            rootClasses() {
                return [
                    this.bemAdd(this.isActiveClass),
                    ...this.bemFacets,
                ];
            },
            isActiveClass() {
                return this.menuSidebar ? 'is-active' : '';
            },
            hamburgerStyles() {
                const inCms = this.facets.includes('in-cms');
                return inCms ? this.scrollLockStyles : {};
            },
            showMobileSwitcher() {
                const inCms = this.facets.includes('in-cms');
                const onHome = this.$route.name === MAP_APP_RECORD_NAMES.HOME;

                return !(inCms || onHome || this.menuSidebar);
            },
        },
    };
</script>
